<template>
  <v-row dense>
    <v-col cols="12">
      <app-title :texto="titulo.toUpperCase()" />
    </v-col>
    <v-col cols="12">
      <v-data-table
        :items="mapeamentosView"
        :headers="headers"
        :search="opcoes.pesquisa"
        :sort-by="opcoes.ordenarPor"
        :sort-desc="opcoes.decrescente"
        item-key="id"
        :show-select="isImportacao"
        show-expand
        single-expand
        class="elevation-0"
      >
        <template v-slot:top>
          <v-row dense>
            <v-col
              cols="12"
              md="4"
            >
              <app-sort v-model="opcoes" />
            </v-col>
            <v-col
              cols="0"
              md="4"
            />
            <v-col
              cols="12"
              md="4"
            >
              <app-search v-model="opcoes" />
            </v-col>
          </v-row>
        </template>
        <template v-slot:[`header.data-table-select`] />
        <template v-slot:[`item.data-table-select`]="{ item }">
          <v-radio-group v-model="mapeamentoSelecionado">
            <v-radio
              :value="item"
              @click="$emit('mapeamento', item)"
            />
          </v-radio-group>
        </template>
        <template
          v-slot:[`item.data-table-expand`]="{ item, expand, isExpanded }"
        >
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                text
                height="100%"
                width="100%"
                @click="expand(!isExpanded)"
                v-on="on"
              >
                <v-badge right>
                  <template v-slot:badge>
                    <span>{{ item.unidades.length }}</span>
                  </template>
                  <v-icon
                    large
                    color="grey lighten-0"
                  >
                    account_balance
                  </v-icon>
                </v-badge>
              </v-btn>
            </template>
            <span>Clique para exibir as unidades vinculadas</span>
          </v-tooltip>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td
            :colspan="headers.length"
            class="justify-center"
          >
            <v-row>
              <v-spacer />
              <v-col>
                <v-row class="justify-center">
                  <h2 class="title primary--text text--darken-1 text-no-wrap">
                    UNIDADES VINCULADAS
                  </h2>
                </v-row>
              </v-col>
              <v-spacer />
            </v-row>
            <v-row>
              <v-spacer />
              <v-col cols="10">
                <v-simple-table
                  class="elevation-0 mb-4"
                  dense
                >
                  <template v-slot:default>
                    <tbody>
                      <tr
                        v-for="unidade in item.unidades"
                        :key="unidade.id"
                      >
                        <td>
                          <div class="d-flex flex-row ma-1">
                            <span class="grey-text text--darken-2">{{
                              `${unidade.sigla} - ${unidade.nome}`
                            }}</span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-spacer />
            </v-row>
          </td>
        </template>
        <template v-slot:[`item.situacao`]="{ item }">
          <v-chip
            class="pa-2"
            :color="item.situacao.cor"
            small
            outlined
          >
            <v-avatar left>
              <v-icon>{{ item.situacao.icone }}</v-icon>
            </v-avatar>
            {{ item.situacao.nome }}
          </v-chip>
        </template>
        <template v-slot:[`item.acoes`]="{ item }">
          <v-col>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-show="
                    item.situacao.id === 'AGENDADO' ||
                      item.situacao.id === 'ATIVO'
                  "
                  icon
                  small
                  color="secondary"
                  class="mr-2"
                  v-on="on"
                  @click="editar(item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
              <span>Clique no botão para editar o mapeamento</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-show="item.situacao.id === 'AGENDADO'"
                  icon
                  small
                  color="error"
                  v-on="on"
                  @click="confirmDelete(item)"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
              <span>Clique no botão para excluir o mapeamento</span>
            </v-tooltip>
          </v-col>
        </template>
      </v-data-table>
    </v-col>

    <dialog-remove
      v-show="dialogs.dialogRemove.visible"
      :confirm-action="deleteMapeamento"
      :dialog-visible="dialogs.dialogRemove.visible"
      :toogle-visible="toogleDialogRemove"
      :descricao="mensagemExclusao"
    />
  </v-row>
</template>

<script>
import { mapState } from 'vuex';
import AppTitle from '@/components/core/AppTitle';
import AppSort from '@/components/core/AppSort';
import AppSearch from '@/components/core/AppSearch';
import DialogRemove from '@/components/DialogRemove';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import Data from '@/modules/data';

const mapeamentoRepository = RepositoryFactory.get('mapeamento');

export default {
  name: 'MapeamentoList',

  components: {
    AppTitle,
    AppSort,
    AppSearch,
    DialogRemove,
  },

  props: {
    titulo: {
      type: String,
      default: 'HISTÓRICO DE MAPEAMENTOS',
      required: false,
    },
    modo: {
      type: String,
      default: 'VISUALIZACAO',
      required: false,
    },
    mapeamento: {
      type: Object,
      default: null,
      required: false,
    },
  },

  data() {
    return {
      mapeamentoSelecionado: null,
      opcoes: {
        pesquisa: '',
        decrescente: false,
        ordenarPor: 'nome',
        selecionado: { id: 'nome', descricao: 'Nome' },
        lista: [
          { id: 'nome', descricao: 'Nome' },
          { id: 'unidade.sigla', descricao: 'Unidade' },
          { id: 'unidades.length', descricao: 'Unidaes Vinculadas' },
          { id: 'inicio', descricao: 'Início' },
          { id: 'fim', descricao: 'Fim' },
          { id: 'situacao.ordem', descricao: 'Situação' },
        ],
      },
      dialogs: {
        dialogRemove: { visible: false, item: null },
      },
    };
  },

  computed: {
    ...mapState({
      mapeamentos: (state) => state.mapeamento.mapeamentosComissao,
    }),
    mapeamentosView() {
      const mapeamentos = this.mapeamentos.map((m) => {
        const unidades = [...m.unidades];
        return {
          ...m,
          unidades: unidades.sort((a, b) => a.sigla.localeCompare(b.sigla)),
          inicio: this.getInicioMapeamento(m),
          fim: this.getFimMapeamento(m),
          situacao: this.getSituacaoMapeamento(m),
        };
      });
      if (this.isImportacao) {
        return mapeamentos.filter((m) => m.situacao.id === 'FINALIZADO');
      }
      return mapeamentos;
    },
    diagnosticos: {
      get() {
        return this.$store.state.diagnostico.diagnosticosComissao;
      },
      set(diagnosticos) {
        this.$store.dispatch('diagnostico/setDiagnosticosComissao', diagnosticos);
      },
    },
    isEdicao() {
      return this.modo === 'EDICAO';
    },
    isImportacao() {
      return this.modo === 'IMPORTACAO';
    },
    headers() {
      const headers = [
        {
          text: 'NOME',
          align: 'start',
          value: 'nome',
          sortable: false,
        },
        {
          text: 'UNIDADE',
          value: 'unidade.sigla',
          sortable: false,
          width: '10%',
          align: 'center',
        },
        {
          text: 'UNIDADES VINCULADAS',
          value: 'data-table-expand',
          sortable: false,
          width: '10%',
          align: 'center',
        },
        {
          text: 'INÍCIO',
          value: 'inicio',
          sortable: false,
          width: this.isEdicao ? '10%' : '15%',
          align: 'center',
        },
        {
          text: 'FIM',
          value: 'fim',
          sortable: false,
          width: this.isEdicao ? '10%' : '15%',
          align: 'center',
        },
      ];
      if (this.isEdicao) {
        headers.push(
          {
            text: 'SITUAÇÃO',
            value: 'situacao',
            sortable: false,
            align: 'center',
          },
          {
            text: 'AÇÕES',
            value: 'acoes',
            sortable: false,
            align: 'center',
          },
        );
      }
      return headers;
    },
    mensagemExclusao() {
      let mensagem = '';
      if (this.dialogs.dialogRemove.item) {
        mensagem = 'Você realmente deseja excluir esse mapeamento? ';
        const isImportado = Boolean(this.dialogs.dialogRemove.item.mapeamentoImportado);
        const diagnosticos = this.diagnosticos.filter((d) => d.mapeamento.id === this.dialogs.dialogRemove.item.id);
        if (isImportado || diagnosticos.length) {
          mensagem += 'Ao prosseguir você também irá excluir ';
          if (isImportado) {
            mensagem += `dados técnicos e comportamentais${diagnosticos.length ? ' e ' : '.'}`;
          }
          if (diagnosticos.length) {
            mensagem += `${diagnosticos.length} diagnóstico${diagnosticos.length > 1 ? 's' : ''}.`;
          }
        }
      }
      return mensagem;
    },
  },

  watch: {
    mapeamento(value) {
      this.mapeamentoSelecionado = value;
    },
  },

  methods: {
    editar(item) {
      this.$emit('update', item);
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    },
    getInicioMapeamento(mapeamento) {
      let inicioComportamental = mapeamento.inicioPerComportServidor;
      const inicioTecnico = mapeamento.inicioPerRespGestor;
      if (
        mapeamento.tipoImportacaoMapeamento
        && mapeamento.tipoImportacaoMapeamento.id === 'IMPORTAR_COMPORTAMENTAL_E_TECNICO'
      ) {
        inicioComportamental = mapeamento.inicioPerComportComissao;
      }

      if (Data.compare('isBefore', { a: inicioComportamental, b: inicioTecnico })) {
        return Data.format(inicioComportamental);
      }
      return Data.format(inicioTecnico);
    },
    getFimMapeamento(mapeamento) {
      if (Data.compare('isAfter', { a: mapeamento.fimPerComportComissao, b: mapeamento.fimPerRespConsol })) {
        return Data.format(mapeamento.fimPerComportComissao);
      }
      return Data.format(mapeamento.fimPerRespConsol);
    },
    getSituacaoMapeamento(mapeamento) {
      let inicioComportamental = mapeamento.inicioPerComportServidor;
      const inicioTecnico = mapeamento.inicioPerRespGestor;
      const fimComportamental = mapeamento.fimPerComportComissao;
      const fimTecnico = mapeamento.fimPerRespConsol;
      if (
        mapeamento.tipoImportacaoMapeamento
        && mapeamento.tipoImportacaoMapeamento.id === 'IMPORTAR_COMPORTAMENTAL_E_TECNICO'
      ) {
        inicioComportamental = mapeamento.inicioPerComportComissao;
      }

      if (Data.compare('isAfter', { b: fimComportamental }) && Data.compare('isAfter', { b: fimTecnico })) {
        return {
          id: 'FINALIZADO',
          nome: 'Finalizado',
          ordem: 3,
          icone: 'check_circle',
          cor: 'success',
        };
      }
      if (Data.compare('isBefore', { b: inicioComportamental }) && Data.compare('isBefore', { b: inicioTecnico })) {
        return {
          id: 'AGENDADO',
          nome: 'Agendado',
          ordem: 1,
          icone: 'alarm',
          cor: 'grey',
        };
      }
      return {
        id: 'ATIVO',
        nome: 'Ativo',
        ordem: 2,
        icone: 'wifi_protected_setup',
        cor: 'secondary',
      };
    },
    confirmDelete(item) {
      this.dialogs.dialogRemove.item = item;
      this.toogleDialogRemove();
    },
    toogleDialogRemove() {
      this.dialogs.dialogRemove.visible = !this.dialogs.dialogRemove.visible;
      if (!this.dialogs.dialogRemove.visible) {
        this.dialogs.dialogRemove.item = {};
      }
    },
    deleteMapeamento() {
      this.$emit('resetForm', true);
      if (this.dialogs.dialogRemove.item.id) {
        mapeamentoRepository.delete(this.dialogs.dialogRemove.item.id).then((response) => {
          const index = this.mapeamentos.findIndex((d) => d.id === this.dialogs.dialogRemove.item.id);
          if (index !== -1) {
            this.mapeamentos.splice(index, 1);
          }
          this.diagnosticos = this.diagnosticos.filter((d) => d.mapeamento.id !== this.dialogs.dialogRemove.item.id);
          this.toogleDialogRemove();
          this.$store.dispatch('app/success', {
            response,
            message: 'Mapeamento excluído com sucesso!',
          });
        });
      }
    },
  },
};
</script>
